import {useState} from "react";
import useDrawer, {defaultConfig} from "./useDrawer";

const useOverflowDrawer = (config = defaultConfig) => {
  const {onEscapeClose: propsOnEscapeClose, ...restConfig} = config;
  const [stack, setStack] = useState([]);
  const {
    close: closeDrawer,
    open: openDrawer,
    ...restDrawerState
  } = useDrawer({
    ...restConfig,
    onEscapeClose: () => {
      clearOverflowContent();
      if (typeof propsOnEscapeClose === "function") {
        propsOnEscapeClose();
      }
    }
  });

  const push = (content) => {
    setStack((state) => [...state, content]);
  };

  const pop = () => {
    setStack((state) => state.slice(0, -1));
  };

  const clearOverflowContent = () => {
    setStack([]);
  };

  const close = () => {
    return closeDrawer().then(clearOverflowContent);
  };

  const open = (data) => {
    return openDrawer(data).then(clearOverflowContent);
  };

  return {
    ...restDrawerState,
    overflowLayersCount: stack.length,
    overflowContent: stack[stack.length - 1],
    addOverflowContent: push,
    removeOverflowContent: pop,
    clearOverflowContent,
    close,
    open
  };
};

export default useOverflowDrawer;
